<template>
  <div
    :class="['charmLevel', isMode && 'charmLevel-afterBox']"
    ref="charmLevel"
  >
    <div style="min-height: 100%;" class="flex flex-direction">
      <div class="charmLevel-box">
        <Navbar
          class="nav-bar"
          :statusHeight="statusHeight"
          :backIcon="
            require(`@/assets/icon_${isMode ? 'back' : 'back_white'}.png`)
          "
          :background="isMode ? '#FFFFFF' : 'transparent'"
          :isNavtiveBack="true"
        >
          <template #title>
            <span
              class="charmLevel-nav-title"
              :style="{ color: isMode ? '#181818' : '#FFFFFF' }"
              >{{ $t('魅力等级说明') }}</span
            >
          </template>
        </Navbar>
        <div class="charmLevel-detail px-14px" :style="{paddingTop: (statusHeight + 66) + 'px'}">
          <div class="user-charm-info flex flex-direction align-center">
            <div class="user-header">
              <img :src="userInfo.headUrl" alt="" />
            </div>
            <div class="user-level-info flex align-center" v-if="userInfo.isGlamourLvel">
              <img
                v-if="userInfo.charm != 0"
                class="user-level-icon"
                :src="userInfo.glamourIcon"
                alt=""
              />
              <span class="user-level-text">{{ userInfo.charm == 0 ? 'LV.0' : userInfo.glamourLevel }}</span>
            </div>
          </div>
          <div class="user-charm-score">
            <p :class="[language, 'flex']"><span>{{ $t('当前用户的魅力值为:')}}</span><span>{{ userInfo.charm  }}</span></p>
            <p v-if="userInfo.glamourLevelNum + 1 < charmList.length">{{ $t('魅力升级:还需xx魅力值可升到下一级', {value: userInfo.nextLevel}) }}</p>
            <p class="user-charm-score-text">
              {{
                $t(
                  '收礼物可获得魅力值，1金币=1魅力值，累计达到对应魅力值可获得对应身份标识。'
                )
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="charmPrivilege-box">
        <span class="privilege-title">{{ $t('魅力等级说明') }}</span>
        <p class="privilege-text">
          {{ $t('魅力等级反馈用户的受欢迎程度，每收到1金币礼物用户魅力值+1') }}
        </p>
        <span class="privilege-title">{{ $t('魅力等级有什么用?') }}</span>
        <p class="privilege-text">
          {{ $t('不同魅力等级获得不同身份标识，以彰显用户人气。') }}
        </p>
        <table class="level-table" align="center">
          <thead>
            <tr class="table-header">
              <th>{{ $t('魅力等级') }}</th>
              <th>{{ $t('等级标识') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, index) in charmList" :key="value.id">
              <td>{{ index + 1 }}</td>
              <td>
                <img :src="value.medalUrl" alt="" class="level-icon" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { appFunc_senToken, appFunc_changeBar } from '@/utils/bridge'
import { CommonModule } from '@/store/modules/common'
import Navbar from '@/components/Navbar.vue'
import { glamourList, getLoginUserInfo } from '@/api'

export default {
  components: { Navbar },
  data() {
    return {
      statusHeight: 44,
      background: 'transparent',
      isMode: false,
      charmList: [],
      usercharm: {},
      activedId: 0,
      userInfo: {
        headUrl: '',
        isGlamourLvel: false,
        glamourIcon: '',
        glamourLevel: '',
        charm: 0,
        nextLevel: 0,
        glamourLevelNum: 0
      }
    }
  },
  watch: {
    isMode: {
      handler(val) {
        appFunc_changeBar({ statusBarModel: val, navBarBackground: '#2e246d' })
      },
      immediate: true
    }
  },
  methods: {
    async init_charms() {
      const {code, data} = await glamourList()
      if(code === 1001 && data?.list)  this.charmList = data.list
    },
    async getUserInfo() {
      const {code, data} = await getLoginUserInfo()
      if(code === 1001 && data) {
        this.userInfo.headUrl = data?.headUrl
        this.userInfo.charm = data?.charm || 0
        const index = this.charmList.findIndex(item => item.id === data?.glamourLevel)
        const userGlamor = this.charmList[index] ||  this.charmList[0]
        const userNextGlamor = this.charmList[index + 1] || {minValue: 0}
        this.userInfo.nextLevel = data?.charm > userNextGlamor?.minValue ? 0 :  userNextGlamor?.minValue - data?.charm
        this.userInfo.isGlamourLvel = userGlamor
        this.userInfo.glamourLevel = 'LV.' + userGlamor?.name
        this.userInfo.glamourLevelNum = index
        this.userInfo.glamourIcon = userGlamor?.medalUrl
      }
    },
    setLanguage() {
      // 获取当前语言
      console.log('setLanguage', window.location.href)
      const data = this.$route.query.language || 'ug'
      this.language = data
      this.$i18n.locale = data
      CommonModule.setLanguage(data)
    },
    async getToken() {
      const res = await appFunc_senToken()
      this.headUrl = res.headUrl
      console.log(res, '/////////////')
      CommonModule.setUserId(res.id)
      CommonModule.setToken(res.tokenForJs)
      CommonModule.setUserPhone(res.mobile)
      CommonModule.setUserName(res.name)
    },
    resultIsmode(e) {
      this.isMode = e.target.scrollTop > 16
    }
  },
  async created() {
    this.setLanguage()
    this.statusHeight = +this.$route.query.statusBarHeight || 0
    // await this.getToken()
    await this.init_charms()
    this.getUserInfo()
  },
  mounted() {
    this.$refs['charmLevel'].addEventListener('scroll', this.resultIsmode)
  },
  beforeDestroy() {
    this.$refs['charmLevel'].removeEventListener('scroll', this.resultIsmode)
  }
}
</script>

<style lang="scss" scoped>
.charmLevel {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  background-color: #251b5c;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 244px;
    background: url('../../assets/charm/charm-container-bg.webp') no-repeat;
    background-size: contain;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  .charmLevel-box {
    .charmLevel-nav-title {
      font-weight: 500;
      font-size: 18px;
      color: #ffffff;
      white-space: nowrap;
    }

    .nav-bar {
      display: block;
      position: fixed;
      width: 100vw;
      box-sizing: border-box;
      z-index: 999;
      padding: 0;
    }

    .charmLevel-detail {
      position: relative;
      z-index: 9;
      width: 100%;
      padding-bottom: 34px;
      .user-charm-info {
        .user-header {
          width: 72px;
          height: 72px;
          border-radius: 50%;
          border: 1px solid #ffffff;
          overflow: hidden;
        }
        .user-level-info {
          padding-top: 4px;
          .user-level-icon {
            width: 45px;
            height: 30px;
            margin-right: 7px;
          }
          font-weight: 500;
          font-size: 16px;
          color: #ffffff;
        }
      }
      .user-charm-score {
        font-weight: 400;
        font-size: 12px;
        color: #c7c0f6;
        padding-top: 12px;
        line-height: 18px;
        p:nth-child(1) {
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
        }
        .user-charm-score-text {
          padding-top: 10px;
        }
      }
    }
  }

  .charmPrivilege-box {
    flex: 1;
    padding: 24px 14px;
    background: #2e246d;
    box-shadow: inset 0px 2px 0px 0px #494a70;
    border-radius: 20px 20px 0px 0px;
    text-align: center;
    .privilege-title {
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      margin: 0 20px;
      display: inline-block;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        left: -18px;
        top: 50%;
        transform: translateY(-50%);
        width: 14px;
        height: 14px;
        background: url('../../assets/charm/icon02.webp') no-repeat;
        background-size: cover;
      }
      &::before {
        content: '';
        position: absolute;
        right: -18px;
        top: 50%;
        transform: translateY(-50%);
        width: 14px;
        height: 14px;
        background: url('../../assets/charm/icon01.webp') no-repeat;
        background-size: cover;
      }
    }
    .privilege-text {
      font-weight: 400;
      font-size: 12px;
      color: #c7c0f6;
      padding-top: 12px;
      text-align: left;
      &:nth-of-type(1) {
        padding-bottom: 27px;
      }
    }
    .level-table {
      width: 100%;
      height: auto;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      margin-top: 12px;
      border-radius: 12px;
      border: 1.5px solid #494a70;
      border-spacing: 0;
      border-collapse: separate; /* 设置为separate以启用圆角效果 */
      overflow: hidden;
      th,
      td {
        height: 36px;
        line-height: 36px;
        border-right: 1.5px solid #494a70;
        border-bottom: 1.5px solid #494a70;
        position: relative;
        .level-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 30px;
          height: 20px;
        }
      }
      td:last-child {
        border-right: 0;
      }
      tr:last-child td {
        border-bottom: 0;
      }
      th:nth-last-of-type(1) {
        border-bottom: 0;
        border-right: 0;
      }
      thead {
        background: #363d7f;
      }
    }
  }
}

.table-header {
  display: flex;
  th {
    flex: 1;
  }
}

tr {
  display: flex;
  td {
    flex: 1;
  }
}

.charmLevel-afterBox::after {
  height: 0;
}

.px-14px {
  padding: 0 14px;
  box-sizing: border-box;
}
</style>
